<template>
  <div class="container">
    <!-- 数据总览 -->
    <div class="overview">
      <div class="overview-listA" @click="clickDetail('all')" style="background-color: #ff6600;">
        <div class="list-title" style="color:#fff">累计收入</div>
        <div class="list-info">
          <span class="info-amount" style="color:#fff">￥ {{detail.sumAmount}}</span>
          <el-image style="width: 40px;" :src="require('@/assets/image/总收入.png')" fit="fit"></el-image>
        </div>
      </div>
      <div class="overview-listB" @click="clickDetail('today')">
        <div class="list-title">今日收入</div>
        <div class="list-info">
          <span class="info-amount">￥ {{detail.sumCurrentToday}}</span>
          <el-image style="width: 40px;" :src="require('@/assets/image/日收入.png')" fit="fit"></el-image>
        </div>
      </div>
      <div class="overview-listC" @click="clickDetail('month')">
        <div class="list-title">本月收入</div>
        <div class="list-info">
          <span class="info-amount">￥ {{detail.sumCurrentMonth}}</span>
          <el-image style="width: 40px;" :src="require('@/assets/image/月收入.png')" fit="fit"></el-image>
        </div>
      </div>
      <div class="overview-listD" @click="clickDetail('year')">
        <div class="list-title">本年收入</div>
        <div class="list-info">
          <span class="info-amount">￥ {{detail.sumCurrentYear}}</span>
          <el-image style="width: 40px;" :src="require('@/assets/image/年收入.png')" fit="fit"></el-image>
        </div>
      </div>
    </div>
    <!-- 门店数据总览 -->
    <div class="overview-store">
      <div class="store-list" style="">
        <div class="top-row">
          <div class="row-title">
            订单总览
            <span class="title-amount">收入总额：￥{{ filteredCompletedIncome }}</span>
          </div>
          <div class="filter-group">
            <el-date-picker
              v-model="datePicker"
              size="small"
              type="daterange"
              align="right"
              unlink-panels
              clearable
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="datePickerOptions"
              @change="handleDateRangeChange"
            >
            </el-date-picker>
            <el-select
              v-model="selectedOrderType"
              clearable
              filterable
              size="small"
              placeholder="全部会员等级"
              style="width: 180px;"
              @change="handleOrderTypeChange"
            >
              <el-option
                v-for="item in memberLevelOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <!-- <el-radio-group v-model="radio" size="medium">
              <el-radio-button v-for="(item,index) in radioGroup" :key="index" :label="item" border></el-radio-button>
          </el-radio-group> -->
        </div>
        <el-table  :data="table" v-loading="loading">
          <el-table-column align="center" prop="id" label="订单编号" width="180"> </el-table-column>

          <el-table-column align="center" prop="orderType" label="会员级别" :formatter="orderTypeFormatter"></el-table-column>
          <el-table-column align="center" prop="userSnapshot.phone" label="用户手机" width="180"> </el-table-column>
          <el-table-column align="center" prop="orderTotalMoney" label="订单金额" width="180"> </el-table-column>
          <el-table-column align="center" prop="orderState" label="订单状态" width="180">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.orderState == 11 ">已完成</el-tag>
<!--              <el-tag type="success" v-else-if="scope.row.orderState == 14 ">待发货</el-tag>-->
              <el-tag v-else>未完成</el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payTime" label="支付时间" width="180"> </el-table-column>
          <el-table-column align="center" prop="createTime" label="创建时间" width="180"> </el-table-column>

          <!-- <el-table-column align="center" prop="" label="操作" width="100">
              <template slot-scope="scope">
                  <el-button type="text" size="small" @click="selectStore(scope.row)">查看详情</el-button>
              </template>
          </el-table-column> -->
        </el-table>
        <!-- 分页 -->
        <div class="wPagination">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pages.current"
              :page-sizes="pages.sizes"
              :page-size="pages.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pages.total">
          </el-pagination>
        </div>
      </div>

      <!-- <div class="store-list" style="height: 605px;">
          <div class="top-row">
              <div class="row-title">门店详情</div>
              <div>当前门店 ：<el-select v-model="storeValue" filterable clearable size="small" placeholder="请选或搜索择门店">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select></div>
          </div>
          <div>
              <el-table  :data="tableDetail" v-loading="loading" style="height: 500px;">
                  <el-table-column align="center" prop="storeId" label="订单编号" width="100"> </el-table-column>
                  <el-table-column align="center" prop="storeName" label="商品名称" > </el-table-column>
                  <el-table-column align="center" prop="orderNum" label="商品数量" width="100"> </el-table-column>
                  <el-table-column align="center" prop="amount" label="订单金额" width="100"> </el-table-column>
                  <el-table-column align="center" prop="" label="操作" width="100">
                      <template slot-scope="scope">
                          <el-button type="text" size="small" @click="selectStore(scope.row)">选择</el-button>
                      </template>
                  </el-table-column>
              </el-table>
          </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { memberOrderListByStore, getMemberAmountApi, getStoreListApi} from "@/network/wApi.js";
export default {
  data() {
    return {
      // radio: "今日",
      // radioGroup: ['今日','本月','本年'],
      datePicker:"",
      datePickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      arrayData:[],
      allOrders: [],
      filteredOrders: [],
      table: [],  //订单列表
      tableDetail: [],
      loading: false,
      pages:{
        current: 1,
        sizes: [10,20],
        size: 10,
        total: 0,
      },
      storeValue: null,
      options:[],
      selectedOrderType: "",
      memberLevelOrder: [814, 815, 822, 817, 816, 824, 819, 818, 820, 821, 823],
      // 查询data
      detail:{
        // header data
        sumAmount: 0,       //所有门店累计收入
        sumCurrentToday: 0, //所有门店今日收入
        sumCurrentMonth: 0, //所有门店本月收入
        sumCurrentYear: 0,  //所有门店本年收入
      },
      orderTypeMap: {
        814: '会员',
        815: 'VIP会员',
        822: '轻创代理',
        817: '社区团长',
        816: '渠道代理',
        824: '开店连锁',
        819: '区县云仓',
        818: '区县代理',
        820: '市级代理',
        821: '省分公司',
        823: '董事合伙人'
      }
    }
  },
  mounted() {
    this.getStoreOverview()
  },
  computed: {
    memberLevelOptions() {
      const orderTypes = new Set(this.allOrders.map(item => String(item.orderType)).filter(Boolean))
      return this.memberLevelOrder
        .filter(value => orderTypes.has(String(value)))
        .map(value => ({
          value,
          label: this.orderTypeMap[value]
        }))
        .concat(
          Object.entries(this.orderTypeMap)
            .filter(([value]) => !this.memberLevelOrder.includes(Number(value)) && orderTypes.has(value))
            .map(([value, label]) => ({
              value: Number(value),
              label
            }))
        )
        .filter(item => item.label)
    },
    filteredCompletedIncome() {
      const total = this.filteredOrders.reduce((sum, item) => {
        if (Number(item.orderState) !== 11) {
          return sum
        }
        const amount = Number(item.orderTotalMoney || 0)
        return sum + (Number.isNaN(amount) ? 0 : amount)
      }, 0)
      return total.toFixed(2)
    }
  },
  methods: {
    // 筛选
    async getOrderList() {
      this.loading = true
      try {
        const countRes = await memberOrderListByStore({
          pageNum: 1,
          pageSize: 1
        })
        const total = countRes.total || 0
        if (!total) {
          this.allOrders = []
          this.updateTableData()
          return
        }
        const listRes = await memberOrderListByStore({
          pageNum: 1,
          pageSize: total
        })
        this.allOrders = listRes.records || []
        this.updateTableData()
      } finally {
        this.loading = false
      }
    },
    // 查看明细
    clickDetail(e){
      let date = new Date()
      if (e == 'all') {
        this.datePicker = []
      }
      if (e == 'today') {
        this.datePicker = [this.formatDate(date), this.formatDate(date)]
      }
      if (e == 'month') {
        this.datePicker = [
          this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1)),
          this.formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0))
        ]
      }
      if (e == 'year') {
        this.datePicker = [
          this.formatDate(new Date(date.getFullYear(), 0, 1)),
          this.formatDate(new Date(date.getFullYear(), 11 , 31))
        ]
      }
      this.pages.current = 1
      this.updateTableData()
    },
    // 门店时间选择器
    changeDatePicker(e){
      const start = e[0]
      const end = e[1]
      const startMM = start.getMonth() < 9 ? "0" + (start.getMonth() + 1) : start.getMonth() + 1;
      const startDD = start.getDate() <= 9 ? "0" + start.getDate() : start.getDate();
      const endMM   = end.getMonth() < 9 ? "0" + (end.getMonth() + 1) : end.getMonth() + 1;
      const endDD   = end.getDate() <= 9 ? "0" + end.getDate() : end.getDate();

      const startDate = start.getFullYear() + '-' + startMM + '-' + startDD
      const endDate   = end.getFullYear() + '-' + endMM + '-' + endDD
      console.log(startDate + ' ' + endDate)
    },
    // 选择门店详情
    selectStore(e){
      console.log("store",e)
      this.storeValue = e.storeId
    },
    // 获取门店数据统计
    getStoreOverview(){
      // this.loading = true
      // 查询供应链年月日累计收入
      // getStoreAmountApi({atype:"3"}).then(res => {
      getMemberAmountApi().then(res => {
        console.log(res)
        this.detail.sumAmount = res.sum
        this.detail.sumCurrentToday = res.today
        this.detail.sumCurrentMonth = res.month
        this.detail.sumCurrentYear = res.year
      })
      this.getOrderList()
    },

    // 当前页面显示多少条数据
    handleSizeChange(e){
      this.pages.size = e
      this.pages.current = 1
      this.updateTableData()
    },
    // 跳转第n页
    handleCurrentChange(e){
      this.pages.current = e
      this.updateTableData()
    },
    handleOrderTypeChange() {
      this.pages.current = 1
      this.updateTableData()
    },
    handleDateRangeChange() {
      this.pages.current = 1
      this.updateTableData()
    },
    formatDate(date) {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
        return ""
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, "0")
      const day = String(date.getDate()).padStart(2, "0")
      return `${year}-${month}-${day}`
    },
    getFilteredOrders() {
      const selectedOrderType = this.selectedOrderType === "" ? null : Number(this.selectedOrderType)
      let filteredOrders = selectedOrderType === null
        ? [...this.allOrders]
        : this.allOrders.filter(item => Number(item.orderType) === selectedOrderType)

      if (Array.isArray(this.datePicker) && this.datePicker.length === 2 && this.datePicker[0] && this.datePicker[1]) {
        const startTime = new Date(`${this.datePicker[0]} 00:00:00`).getTime()
        const endTime = new Date(`${this.datePicker[1]} 23:59:59`).getTime()
        filteredOrders = filteredOrders.filter(item => {
          const sourceTime = item.payTime || item.createTime
          if (!sourceTime) {
            return false
          }
          const currentTime = new Date(sourceTime).getTime()
          if (Number.isNaN(currentTime)) {
            return false
          }
          return currentTime >= startTime && currentTime <= endTime
        })
      }

      return filteredOrders
    },
    updateTableData() {
      const filteredOrders = this.getFilteredOrders()
      this.filteredOrders = filteredOrders
      this.pages.total = filteredOrders.length
      const startIndex = (this.pages.current - 1) * this.pages.size
      const endIndex = startIndex + this.pages.size
      this.table = filteredOrders.slice(startIndex, endIndex)
    },
    orderTypeFormatter(row) {
      return this.orderTypeMap[row.orderType] || row.orderType;
    }
  }
}
</script>
<style lang='less' scoped>
@import "@/assets/css/publicStyle.less";

.container {
  .overview {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .overview-listA:hover{
      background-color: rgb(233, 233, 233);
    }
    .overview-listB:hover{
      background-color: rgb(233, 233, 233);
    }
    .overview-listC:hover{
      background-color: rgb(233, 233, 233);
    }
    .overview-listD:hover{
      background-color: rgb(233, 233, 233);
    }
    .overview-listA,
    .overview-listB,
    .overview-listC,
    .overview-listD {
      background-color: #fff;
      width: calc((100%)/4 - 60px);
      border-radius: 10px;
      padding: 20px;
      .list-title {
        font-size: 14px;
      }
      .list-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        .info-amount {
          font-size: 25px;
          font-weight: bold;
          color: #ff6600;
        }
      }
    }

  }

  .overview-store {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    .store-list {
      background-color: #fff;
      border-radius: 20px;
      width: calc(100% - 40px);
      padding: 20px;
      .top-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .row-title {
          font-size: 20px;
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .title-amount {
          font-size: 14px;
          color: #ff6600;
          font-weight: 600;
        }
        .filter-group {
          display: flex;
          align-items: center;
          gap: 12px;
        }
      }
    }
  }
}
</style>
